export default {
  back: "Back",
  ctaText: "Let’s see the final score",
  distribution: "Distribution",
  locations: "Locations",
  productionLines: "Production Lines",
  sidePanelSubtitle: "Review your actions.",
  sidePanelTitle: "End of day!"
};
